import OAButton from "./components/OAButton";
import { useTranslation } from "react-i18next";
import { useConfig } from "./ConfigProvider";

const pictoDescriptions = [
  { src: "oa-link.svg", alt: "LINK OA" },
  { src: "free-network.svg", alt: "FREE NETWORK" },
  { src: "oa-figure.svg", alt: "FIGURE" },
  { src: "picto_fontaine.png", alt: "FONTAINE" },
  { src: "picto_sismo.png", alt: "SISMO" },
  { src: "picto_vis_body.png", alt: "OPTIONS" },
];

export default function Choice({ value, selected, onSelect }) {
  const { t } = useTranslation();
  const { currency } = useConfig();
  const mql = window.matchMedia("(max-width: 600px)");
  const isMobile = mql.matches;
  const found = selected.find((f) => f["@id"] === value["@id"]);
  const isSelected = !!found;
  const mandatory = isSelected && !!found.mandatory;
  const onClick = (e) => {
    if (mandatory || !onSelect) return;
    onSelect(value);
  };
  return (
    // w-full md:w-[492px] bg-[url('/src/assets/oa-offers-bg.svg')] bg-no-repeat bg-right bg-white flex flex-col py-20 px-9 md:px-14 rounded-[8px]
    <div>
      <div className={`bg-oaRed text-white p-1.5 rounded-t-md mb-[-5px] ${value.topOffer !== 1 && "invisible"}`}>
        <p className="pb-1 font-semibold text-center">{t("offer_selection.offer_card.banner_top_offer")}</p>
      </div>
      <article
        className={`w-full flex flex-col py-20 px-9 md:px-14 rounded-[8px] bg-[url('/src/assets/oa-offers-bg.svg')] bg-no-repeat bg-right bg-white ${
          !isMobile && "shadow-md shadow-black/50 transition-all duration-500"
        } `}
      >
        <header className="flex flex-col mb-4">
          <div></div>
          <div className="w-fit text-oaRed font-semibold text-4xl md:text-5xl pb-5 mb-10 border-b-2 border-oaRed">
            {value.d.name}
          </div>
          <section className="flex flex-row items-start gap-2 mb-1">
            <strong className="text-[60px] md:text-[60px] leading-none font-bold italic">{value.d.price_1}</strong>
            <div className="flex" style={{ alignItems: "center", gap: "0.3rem" }}>
              <strong className="text-[38px] md:text-[52px] font-bold italic">
                {value.d.price_2 && `,${value.d.price_2}`}
                {currency}
              </strong>
              <strong className="text-[18px] md:text-[24px] font-bold italic">{value.d.price_3}</strong>
            </div>
          </section>
          <section className="text-base mb-5">{value.d.price_4}</section>
          <section className="text-[10px] font-medium mb-1">{value.d.txt}</section>
        </header>

        <section className="mt-2">
          <ul>
            {!!value.d.features.length &&
              value.d.features.map((d, idx) => {
                if (!d) return null;
                if (!pictoDescriptions[idx]) {
                  return null;
                }
                return <PictoAndText picto={pictoDescriptions[idx]} text={d} key={`item-${idx}`} />;
              })}
          </ul>
        </section>

        <OAButton className={"h-12 text-xl lg:h-16 lg:text-2xl font-bold italic"} onClick={onClick}>
          {t("offer_selection.offer_card.isub")}
        </OAButton>
      </article>
    </div>
  );
}

function PictoAndText({ picto, text }) {
  return (
    <li className="flex flex-row text-sm md:text-xl items-center mb-10 gap-5">
      <img className="size-7 object-contain" src={picto.src} alt={picto.alt} />
      <div>
        <span className="font-normal">{text}</span>
      </div>
    </li>
  );
}
